<template>
    <div>
        <el-form ref="form" :model="edit" label-width="7em" class="baseInfoForm">
            <el-form-item label="已选标签" prop="checkLabels" verify>
                <el-tag :key="tag"
                        style="margin: 0px 3px;"
                        v-for="tag in edit.checkLabels"
                        closable
                        :disable-transitions="false"
                        @close="handleAppraiseClose(tag)"> {{tag}}
                </el-tag>
            </el-form-item>

            <el-form-item label="定义标签">
                <el-input
                        class="input-new-tag"
                        v-if="inputAppraiseVisible"
                        v-model.trim="inputAppraiseValue"
                        ref="saveAppraiseTagInput"
                        size="small"
                        maxlength="8"
                        show-word-limit
                        @keyup.enter.native="handleAppraiseInputConfirm"
                        @blur="handleAppraiseInputConfirm">
                </el-input>
                <el-button v-else class="button-new-tag" size="small" :disabled="addEnable"
                           @click="showAppraiseInput">+ 添加
                </el-button>
            </el-form-item>

            <el-form-item label="标签过滤">
                <el-input size="small" placeholder="请输入关键词" suffix-icon="el-icon-search"
                          v-model="appraiseFilterKey">
                </el-input>
            </el-form-item>

            <el-form-item label="选择标签">
                <el-checkbox-group v-model="edit.checkLabels" size="mini" class="welfareList" :min="0"
                                   :max="5">
                    <el-checkbox-button
                            v-for="label in defaultKeyword.children.filter(x => x.labelName.indexOf(appraiseFilterKey) > -1)"
                            :label="label.labelName"
                            :key="label.id">{{label.labelName}}
                    </el-checkbox-button>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleKeywordSubmit">保存</el-button>
                <el-popconfirm title="确认取消编辑？"
                               @confirm="cancel()"
                               placement="top-start"
                               icon="el-icon-info"
                               icon-color="red"
                               class="ml10">
                    <el-button slot="reference">取消</el-button>
                </el-popconfirm>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import {saveResumeKeywordList} from '@/api/resumeKeyword'
    import {findLeafLabel} from '@/api/label';

    export default {
        name: 'ResumeKeywordForm',
        props: ['edit', 'resumeId', 'editStatus'],
        data() {
            return {
                sizeLimit: 5, //数值限制
                defaultKeyword: {
                    id: 1,
                    children: []
                },
                // edit: {
                //     checkLabels: [] //选中评价标签
                // },
                inputAppraiseValue: '',
                appraiseFilterKey: '',
                inputAppraiseVisible: false
            }
        },
        created() {
            /** 获取简历关键词下的所有标签 */
            findLeafLabel(this.defaultKeyword.id).then((res) => {
                this.defaultKeyword.children = res.data;
            })
        },
        watch: {
            form() {
                this.edit.checkLabels = [];
                if (this.form && this.form.keywordList) {
                    this.form.keywordList.forEach(x => this.edit.checkLabels.push(x.labelName));
                }
            }
        },
        computed: {
            addEnable() {
                return !(this.edit.checkLabels.length < this.sizeLimit);
            }
        },
        methods: {
            //移除已选关键词
            handleAppraiseClose(val) {
                this.edit.checkLabels.splice(this.edit.checkLabels.indexOf(val), 1);
            },
            //显示关键词输入框
            showAppraiseInput() {
                this.inputAppraiseVisible = true;
                this.$nextTick(() => {
                    this.$refs.saveAppraiseTagInput.$refs.input.focus();
                });
            },
            //添加关键词
            handleAppraiseInputConfirm() {
                if (this.edit.checkLabels && this.edit.checkLabels.length == 5) {
                    this.inputAppraiseVisible = false;
                    this.inputAppraiseValue = '';
                    return;
                }
                let inputValue = this.inputAppraiseValue;
                if (inputValue) {
                    if (this.edit.checkLabels.indexOf(inputValue) != -1) {
                        this.msgError("重复的标签！");
                        this.$nextTick(() => {
                            this.$refs.saveAppraiseTagInput.$refs.input.focus();
                        });
                        return;
                    }
                    this.edit.checkLabels.push(inputValue);
                }
                this.inputAppraiseVisible = false;
                this.inputAppraiseValue = '';
            },
            //提交标签
            handleKeywordSubmit() {
                let params = {
                    resumeId: this.resumeId,
                    keywordList: []
                };
                let tagList = [];
                this.edit.checkLabels.forEach((key) => {
                    let item = this.defaultKeyword.children.find(x => x.labelName == key);
                    if (item) {
                        tagList.push({
                            labelId: item.id,
                            labelName: item.labelName,
                            labelTypeId: this.defaultKeyword.id,
                            labelTypeName: this.defaultKeyword.labelName
                        })
                    } else {
                        tagList.push({
                            labelName: key,
                            labelTypeId: this.defaultKeyword.id,
                            labelTypeName: this.defaultKeyword.labelName
                        })
                    }
                });
                params.keywordList = tagList;
                saveResumeKeywordList(params).then((res) => {
                    this.cancel();
                    this.$store.commit('changeResumeRefreshFlag', true);
                });
            },

            // 简历工作经历表单取消编辑状态
            cancel() {
                this.editStatus.status = false;
                this.$emit('editStatus', this.editStatus);
                this.$store.commit('changeResumeEditStatus', false);
                this.$store.commit('changeResumeKeywordEditStatus', false);
            },
        }

    };
</script>